import React from 'react';
import { defineSignalElement } from 'wisp-lib';

import { useConfig } from '../../defaultConfig';
import useWispSignal from '../../fetchHooks/useWispSignal';

import './WispSignal.scss';

if (!customElements.get('wisp-signal-element')) {
    defineSignalElement();
}

// using a color that works on different themes and dark mode plugins
const WISP_SIGNAL_COLOR = '[128,128,128]';

const WispSignal: React.FC = () => {
    const { featureToggles } = useConfig();
    const { data: wispSignal } = useWispSignal();
    if (!wispSignal?.value || !featureToggles.enableWispSignal) {
        return null;
    }
    return (
        <div className="wisp-signal__container">
            <wisp-signal-element data-data={wispSignal.value} data-color={WISP_SIGNAL_COLOR} data-vertical={false} />
        </div>
    );
};

export default WispSignal;
